export default class MenuService {
  /* @ngInject */
  constructor(HttpService, AuthService, GeographyService, CommunicationToolService, ProductFilterService, MENU_CONSTANT) {
    this.MENU_CONSTANT = MENU_CONSTANT;
    this.httpService = HttpService;
    this.authService = AuthService;
    this.geographyService = GeographyService;
    this.communicationToolService = CommunicationToolService;
    this.productFilterService = ProductFilterService;
  }

  get() {
    const storeId = this.authService.currentStoreId();
    return this.geographyService.storeDetail(storeId)
      .then((storeData) => {
        const marketId = storeData.market.id;
        return this.httpService.all([
          this.httpService.get(this.productFilterService.createBaseFilterPathForGender('W', storeId, marketId)),
          this.httpService.get(this.productFilterService.createBaseFilterPathForGender('M', storeId, marketId)),
          this.httpService.get(this.productFilterService.createBaseFilterPathForGender('B', storeId, marketId)),
          this.httpService.get(this.productFilterService.createBaseFilterPathForGender('X', storeId, marketId)),
          this.communicationToolService.getCategories(),
          storeData,
        ]);
      })
      .then(([woman, man, kids, unisex, categories, storeData]) => {
        const products = [woman, man, kids, unisex].map((res) => {
          const data = res.data.data;
          const genderKey = Object.keys(data.gender)[0];
          return this.createGroup({
            key: genderKey,
            label: data.gender[genderKey],
            children: this._createChildGenderProduct(genderKey, data.category, storeData)
              .sort((a, b) => a.label > b.label ? 1 : -1),
          });
        });

        const communicationTools = this.createGroup({
          key: this.MENU_CONSTANT.KEY.COMMUNICATION_TOOLS,
          slug: 'COMMUNICATION_TOOLS',
          children: categories
            .map(category => this._createChildCommunicationTool(category)),
            // .filter(link => this._removeLinkForPS(link)),
        });
        return [...products, communicationTools];
      });
  }

  createGroup({key, label, children = [], params = {}, state, slug, matchOnUrl, matchOnSearch}) {
    return {key, label, children, state, params, isOpen: false, slug, matchOnUrl, matchOnSearch};
  }

  _createChildGenderProduct(genderKey, categories, storeData) {
    return Object.keys(categories)
      .map(key => this.createGroup({
        key,
        label: categories[key],
        state: 'products',
        params: {
          genderId: genderKey,
          categoryId: key,
          typeId: null,
          productlineId: null,
          seasonId: null,
          themeId: null,
          marketsegmentId: null,
          q: null,
          regionId: storeData.region.id,
          marketId: storeData.market.id,
        },
      }));
  }

  _createChildCommunicationTool(child) {
    return this.createGroup({
      key: child.id,
      slug: child.slug || child.name,
      state: 'communicationTools',
      params: {categoryId: child.id, slug: child.slug},
    });
  }

  // _removeLinkForPS(link) {
  //   const isCatalogues = link.slug === 'PRODUCT_CATALOGUES';
  //   const isEditorials = link.slug === 'EDITORIALS';
  //   if (this.authService.isPersonalShopper() && (isCatalogues || isEditorials)) {
  //     return false;
  //   }
  //   return true;
  // }
}



// WEBPACK FOOTER //
// ./src/app/shared/menu/menu.service.js